import Component from './component';
import createComponentFactory from '../createComponent';
import { Expo, TweenMax } from 'gsap/umd/TweenMax';
import { wait } from '../utils/promises/wait';
import { splashCompleteAction } from '../action/splashAction';

class Splash extends Component {
  constructor(element, context, options) {
    super(element, context, options);

    this._waitClose();
  }

  _waitClose() {


    return wait(1000).then(() => {
      this.channel.root.sendDownstream(splashCompleteAction);

      this._fadeOut().then(() => {
        this.element.style.display = 'none';
      });
    });
  }

  _fadeOut() {

    return new Promise((resolve) => {
      this.element.style.pointerEvents = 'none';

      TweenMax.to(this.element, 2, {
        opacity: 0,
        ease: Expo.easeOut,
        onComplete: () => {
          resolve();
        }
      });
    });
  }

  didRegisterComponent() {
  }

  didUnregisterComponent() {
  }
}

export default createComponentFactory(Splash);



// WEBPACK FOOTER //
// ./src/js/app/component/splash.js